import React, { Component, PropTypes } from "react";
import { DefaultSearch, SearchKeyword, BaypageM } from "../../Model/Content"; //Include Home
import { Loggedin, NonLoggedin } from "../user/User"; //Include Content API
import { Helmet } from "react-helmet";
import Search from "../search/Search";
import DeskSearch from "../search/DeskSearch";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import {
  SVGIcons,
  ImgIcons,
  Appsflyer,
  VirsionCheck,
  branchIO,
} from "../../Helpers/Common";
import Notification from "../Notification/Notification";
import Allbays from "../Allbays/Allbays";
import { getTopics } from "../../Model/Common";
import { getGeoInfo } from "../../Model/Users";

var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));
export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userdata: false,
      NotificationClick: false,
      Showallbays: false,
      SearchIcon: false,
      Searchdata: false,
      ContentSlug: false,
      searchKey: false,
      searchkeyword: false,
      isLive: true,
      Baysdata: [],
      goldenDIcon: "",
      silverDIcon: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    VirsionCheck().then((vcheckres) => {
      if (vcheckres.data) {
        this.setState({
          isLive: JSON.parse(vcheckres.data).data.is_live_tv,
          goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
          silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
        });
      }
    });
    var ContentSlug = window.location.pathname;
    ContentSlug = ContentSlug.split("/");
    ContentSlug = ContentSlug[2];
    getTopics().then((topicsList) => {
      var Topicslist = topicsList.data.message;
      return this.setState({
        Baysdata: Topicslist.Genres,
      });
    });

    if (this.props.page == "baypage") {
      BaypageM(ContentSlug).then((res) => {
        // Appsflyer("Bay Page Visited", { "Bay Name": ContentSlug });
        // branchIO("Bay Page Visited", { "Bay Name": ContentSlug });
      });
    }
    this.setState({ ContentSlug: ContentSlug });
    this.setState({
      userdata: this.props.userprofile,
    });
  }
  SearchClose() {
    this.setState({
      SearchClick: false,
    });
  }
  search() {
    this.setState({
      SearchClick: true,
    });
  }
  Notification() {
    this.setState({
      NotificationClick: true,
    });
  }
  NotificationClose() {
    this.setState({
      NotificationClick: false,
    });
  }
  Showallbays() {
    this.setState({
      Showallbays: true,
    });
  }
  ShowallbaysClose() {
    this.setState({
      Showallbays: false,
    });
  }

  handleChange(e) {
    var SearchKey = e.target.value;

    getGeoInfo().then((res) => {
      var PostData = {
        searchkeyword: SearchKey,
        seesionID: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID"),
        is_child:localStorage.getItem("is_child_local_storage")
      };

      this.setState({ searchkeyword: SearchKey });

      // const { value } = e.target;

      // this.setState({ inputValue: value });

      // if (value.length >= 3) {
      //   SearchKeyword(PostData, res).then((SearchkeywordResp) => {
      //     if (SearchkeywordResp.data.message.body) {
      //       this.setState({
      //         Searchdata: JSON.parse(SearchkeywordResp.data.message.body),
      //         SearchIcon: true,
      //       });
      //     }
      //   });
      // } if (SearchKey === "") {
      //   this.setState({
      //     SearchIcon: false,
      //     searchkeyword: false,
      //   });
      // }

      function debounceAndThrottle(func, delay) {
        let timeout;
        let lastRun = 0;

        return function executedFunction(...args) {
          const context = this;
          const currentTime = new Date().getTime();

          clearTimeout(timeout);

          if (currentTime - lastRun >= delay) {
            func.apply(context, args);
            lastRun = currentTime;
          } else {
            timeout = setTimeout(() => {
              func.apply(context, args);
              lastRun = new Date().getTime();
            }, delay - (currentTime - lastRun));
          }
        };
      }

      const delayedSearch = debounceAndThrottle((value) => {
        if (value.length >= 3) {
          SearchKeyword(PostData, res).then((SearchkeywordResp) => {
            if (SearchkeywordResp.data.message.body) {
              this.setState({
                Searchdata: JSON.parse(SearchkeywordResp.data.message.body),
                SearchIcon: true,
              });
            }
          });
        } else {
          this.setState({
            Searchdata: null,
            SearchIcon: false,
            searchkeyword: false,
          });
        }
      }, 500);

      const { value } = e.target;
      this.setState({ inputValue: value });
      delayedSearch(value);

    });

    /*else {
      DefaultSearch().then((DefaultSearchResp) => {
        
        this.setState({
          Searchdata: JSON.parse(DefaultSearchResp.data.message.body),
          SearchIcon: true,
        });
      });
    }*/
  }

  render() {
    const { userdata } = this.state;
    let button;

    let showBayData = this.state.Baysdata.filter((data) => {
      if (data.name.toLowerCase() != this.state.ContentSlug) return data;
    });

    var headerNone = this.props.page;

    if (this.state.NotificationClick === true) {
      return <Notification functions={this} />;
    }

    if (this.state.Showallbays === true) {
      return <Allbays functions={this} baydata={this.state.Baysdata} />;
    }
    document.addEventListener("scroll", () => {
      const header = document.querySelector("header");
      if (header) {
        if (window.scrollY > 10) {
          header.classList.add("head-hide");
        } else {
          header.classList.remove("head-hide");
        }
      }
    });
    //this.sea = this.props.classdata;
    if (this.state.SearchClick === true) {
      return (
        <Search
          functions={this}
          closefrom="true"
          goldenIcon={this.state.goldenDIcon}
          silverIcon={this.state.silverDIcon}
        />
      );
    } else if (this.state.userdata) {
      return (
        <>
          <div className="banner-overlay dD-block"></div>
          <div className="dD-none">
            <div className="mainNav">
              {headerNone == "home" ? (
                <>
                  <Link to="/">
                    <div className="docubayLogo">
                      <img
                        src={ImageData["docu-bay-white.png"]}
                        alt="DocuBay Logo"
                      />
                    </div>
                  </Link>
                  <div className="navTabs">
                    <Link to="/movies">Films</Link>
                    <Link to="/series">Series</Link>
                  </div>
                  {/* {this.state.userdata.is_subscribed ? null : (
                    <Link to="/become-a-member" className="bcomem">
                      <div> Become A Member </div>
                    </Link>
                  )} */}

                  <div className="navRight">
                    <div className="navList">
                      <ul>
                        <li>
                          <span
                            href=""
                            onClick={() => {
                              this.search();
                            }}
                            className="search1"
                          >
                            <img src={SVGIcon["search.svg"]} />
                          </span>
                        </li>

                        <li>
                          {/* <div className="notification"></div> */}
                          <span
                            className="notification1"
                            onClick={() => this.Notification()}
                          >
                            <img src={SVGIcon["notifications.svg"]} />
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : null}

              {headerNone == "movies" ? (
                <>
                  <Link to="/">
                    <div className="docubayBack white">
                      <img src={SVGIcon["back.svg"]} alt="DocuBay" /> Films
                    </div>
                  </Link>
                  <div className="nav-dropDown">
                    <a onClick={() => this.Showallbays()}>
                      All Bays <img src={SVGIcon["allbay-arrow.svg"]} />{" "}
                    </a>
                  </div>
                  <div className="navRight">
                    <div className="navList">
                      <ul>
                        <li>
                          <span
                            href=""
                            onClick={() => {
                              this.search();
                            }}
                            className="search1"
                          >
                            <img src={SVGIcon["search.svg"]} />
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : null}

              {headerNone == "series" ? (
                <>
                  <Link to="/">
                    <div className="docubayBack white">
                      <img src={SVGIcon["back.svg"]} alt="DocuBay" /> Series
                    </div>
                  </Link>
                  <div className="nav-dropDown"></div>
                  <div className="navRight">
                    <div className="navList">
                      <ul>
                        <li>
                          {/* <a> */}
                          <img
                            src={SVGIcon["search.svg"]}
                            onClick={() => {
                              this.search();
                            }}
                          />
                          {/* </a> */}
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : null}

              {headerNone == "baypage" ? (
                <>
                  <Link to="/movies">
                    <div className="docubayBack white">
                      <img src={SVGIcon["back.svg"]} alt="DocuBay" /> Films
                    </div>
                  </Link>
                  <div className="nav-dropDown">
                    <a
                      className="temp54-modal-toggle"
                      onClick={() => this.Showallbays()}
                    >
                      {this.state.ContentSlug}
                      <span className="red">Bay</span>{" "}
                      <img src={SVGIcon["allbay-arrow.svg"]} />{" "}
                    </a>
                  </div>
                  <div className="navRight">
                    <div className="navList">
                      <ul>
                        <li>
                          <div
                            className="search1"
                            onClick={() => {
                              this.search();
                            }}
                          >
                            <img src={SVGIcon["search.svg"]} />
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <header className="dD-block header">
            <div className="deskMain-nav">
              <div className="head-right">
                <div className="docubayLogo">
                  <Link to="/">
                    <img
                      src={ImageData["docu-bay-white.png"]}
                      alt="DocuBay Logo"
                    />
                  </Link>
                </div>
                <div className="desk-nav">
                  <Link to="/">Home</Link>
                  <Link to="/movies">Films</Link>
                  <Link to="/series">Series</Link>
                  {/* <a href="#" className="temp54-modal-toggle">DocuBytes</a> */}
                  <Link to="/watch-list">Watchlist</Link>
                </div>
              </div>
              {headerNone == "series" || headerNone == "baypage" ? null : (
                <>
                  <li className="dropdown">
                    All Bays
                    <ul className="dropdown_menu dropdown_menu-2">
                      {this.state.Baysdata.map((data, index) => {
                        return (
                          <li className="dropdown_item-1" key={data.name}>
                            <a href={"/baypage/" + data.name.toLowerCase()}>
                              <div className="droplayout">
                                <div className="bay-text">{data.name}</div>
                                <span className="red">Bay</span>
                              </div>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                </>
              )}

              {headerNone == "baypage" ? (
                <>
                  <div className="nav-dropDown1">
                    <a>
                      {this.state.ContentSlug}
                      <span className="red">Bay</span>
                      <img src={SVGIcon["allbay-arrow.svg"]} />
                    </a>
                    <ul className="dropdown_menu dropdown_menu-2">
                      {showBayData.map((data, index) => {
                        return (
                          <li className="dropdown_item-1" key={data.name}>
                            <a href={"/baypage/" + data.name.toLowerCase()}>
                              <div className="droplayout">
                                <div className="bay-text">{data.name}</div>
                                <span className="red">Bay</span>
                              </div>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </>
              ) : null}

              <div className="head-right">
                <input
                  type="search"
                  name="q"
                  className="search-text"
                  placeholder="Search"
                  autoComplete="off"
                  onChange={this.handleChange}
                />
                {headerNone == "home" ||
                  headerNone == "series" ||
                  headerNone == "movies" ||
                  headerNone == "baypage" ? (
                  <>
                    {/* <div className="head-container">
                      <div className="deskMain-navMid">
                        {this.state.userdata.is_subscribed ? null : (
                          <Link to="/become-a-member" className="bcomem-desk">
                            <div> Become A Member </div>
                          </Link>
                        )}
                      </div>
                    </div> */}
                  </>
                ) : null}

                {/* {headerNone == "details" ? (
                  <>
                    <div className="head-container">
                      <div className="deskMain-navMid">
                        {userdata.is_subscribed ? null : (
                          <Link to="/become-a-member" className="bcomem-desk">
                            <div> Become A Member </div>
                          </Link>
                        )}
                      </div>
                    </div>
                  </>
                ) : null} */}

                <div className="lastNav-desk">
                  <ul>
                    <li>
                      <Link to="/manage-membership">
                        <img src={SVGIcon["profile-desk.svg"]} />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </header>
          {this.state.SearchIcon && this.state.searchkeyword !== false ? (
            <DeskSearch
              searchedData={this.state.Searchdata}
              functions={this}
              goldenIcon={this.state.goldenDIcon}
              silverIcon={this.state.silverDIcon}
            />
          ) : null}
        </>
      );
    } else {
      return (
        <>
          <div className="dD-none">
            <div className="mainNav detail-mainNav detail-header-desk">
              <>
                <Link to="/">
                  <div className="docubayLogo">
                    <img
                      src={ImageData["docu-bay-white.png"]}
                      alt="DocuBay Logo"
                      className="detail-mobile-logo"
                    />
                  </div>
                  <div className="docubayLogo">
                    <img
                      src={ImageData["DocuBay-TitleLogo-BlackBg.png"]}
                      alt="DocuBay Logo"
                      className="detail-tablet-logo"
                    />
                  </div>
                </Link>
                <div className="navTabs"></div>
                <Link
                  to="/createaccount"
                  className="bcomem detail-header-btn detail-create-desk"
                >
                  <div> Create Account </div>
                </Link>
                <Link
                  to="/createaccount"
                  className="bcomem detail-header-btn detail-login-desk"
                >
                  <div> Log In </div>
                </Link>
              </>
            </div>
          </div>
          <div className="deskMain-nav ">
            <header className="dD-block header">
              <div className="deskMain-nav detail-header-desk">
                <div className="head-right">
                  <div className="docubayLogo detail-docubay-logo">
                    <Link to="/">
                      <img
                        src={ImageData["DocuBay-TitleLogo-BlackBg.png"]}
                        alt="DocuBay Logo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="head-right">
                  <div className="head-container">
                    <div className="deskMain-navMid">
                      <p className="text-white">
                        WATCH DOCUMENTARY FILMS & SERIES
                      </p>
                    </div>
                  </div>
                  <div className="head-container">
                    <div className="deskMain-navMid">
                      <Link
                        to="/createaccount"
                        className="bcomem-desk detail-create-desk"
                      >
                        <div> Create Account </div>
                      </Link>
                    </div>
                  </div>
                  <div className="head-container">
                    <div className="deskMain-navMid">
                      <Link
                        to="/createaccount"
                        className="bcomem-desk detail-login-desk"
                      >
                        <div> Log In </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </header>
          </div>
        </>
      );
    }
  }
}
